import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-home-about',
  templateUrl: './home-about.component.html',
  styleUrls: ['./home-about.component.css']
})
export class HomeAboutComponent implements OnInit {

  @Input() data : any;
  
  constructor() { }

  ngOnInit(): void {
  }

}
